import React, { useState } from 'react';
import { toast } from 'react-hot-toast';
import { Modal } from 'reactstrap';
import {
  IconTrashFilled,
  IconPencilFilled,
  IconTakeatClub,
} from 'takeat-design-system-ui-kit';
import api2 from '~/services/api2';
import formatCompleteDate from '~/services/formatDate';
import EditTicket from '../Edit';

import { Actions, Delete } from './styles';

function Coupom({ coupom, getTickets }) {
  const [isModalEditTicketOpen, setIsModalEditTicketOpen] = useState(false);

  function toggleModalEditTicket() {
    setIsModalEditTicketOpen(!isModalEditTicketOpen);
  }

  async function handleDelete(id) {
    try {
      if (window.confirm('Tem certeza que deseja deletar este cupom?')) {
        await api2.delete(`/restaurants/discount-coupons/${id}`);
        getTickets();
        toast.success('Cupom deletado com sucesso!');
      }
    } catch (error) {
      toast.error('Erro ao deletar cupom');
    }
  }
  return (
    <tr key={coupom.id}>
      <Modal
        isOpen={isModalEditTicketOpen}
        toggle={toggleModalEditTicket}
        size="lg"
      >
        <EditTicket
          coupom={coupom}
          getTickets={getTickets}
          toggleModalEditTicket={toggleModalEditTicket}
        />
      </Modal>
      <td>{coupom.code}</td>
      <td>{coupom.name}</td>
      <td>
        {coupom.is_campaign !== false && (
          <IconTakeatClub fontSize={20} fill="#C8131B" />
        )}
        {coupom.accepted_channels.length > 1
          ? `${coupom.accepted_channels.reduce((actual, next) => {
              const formattedActual =
                actual.charAt(0).toUpperCase() + actual.slice(1);
              const formattedNext =
                next.charAt(0).toUpperCase() + next.slice(1);
              return ` ${formattedNext} e ${formattedActual}`;
            })}`
          : ' ' +
              coupom.accepted_channels[0].slice(0).charAt(0).toUpperCase() +
              coupom.accepted_channels[0].slice(1) || '-'}
      </td>
      <td>{coupom.is_public ? 'Sim' : 'Não'}</td>

      <td>
        {coupom.discount_type === 'absolute' && `R$${coupom.discount}`}
        {coupom.discount_type === 'percentage' &&
          `${(parseFloat(coupom.discount) * 100).toFixed(2)}%`}
        {coupom.discount_type === 'free-shipping' && `FRETE`}
      </td>
      <td>R${coupom.minimum_price}</td>
      <td>R${coupom.maximum_discount}</td>
      <td>{coupom.limit_amount || ' - '}</td>
      <td>
        {coupom.used_amount} {coupom.used_amount === 1 ? 'vez' : 'vezes'}
      </td>
      <td>
        {coupom.limit_date === null
          ? 'Sem expiração'
          : formatCompleteDate(coupom.limit_date)}
      </td>
      <td>
        {' '}
        <Actions>
          <IconPencilFilled
            onClick={toggleModalEditTicket}
            fontSize={17}
            style={{ cursor: 'pointer' }}
          />

          <Delete onClick={() => handleDelete(coupom.id)}>
            <IconTrashFilled fontSize={17} fill="#ff0000" />
          </Delete>
        </Actions>
      </td>
    </tr>
  );
}

export default Coupom;
